export const FETCH_HOME_PAGE_REQUEST = 'HOME_PAGE/FETCH_HOME_PAGE_REQUEST';
export const FETCH_HOME_PAGE_FAILURE = 'HOME_PAGE/FETCH_HOME_PAGE_FAILURE';
export const FETCH_HOME_PAGE_SUCCESS = 'HOME_PAGE/FETCH_HOME_PAGE_SUCCESS';
